/* Shared contact dropdown. Native selects submit values and provide a no-JS fallback. */
(function () {
  'use strict';
  if (window.cpkEnquirySelectReady) { return; }
  window.cpkEnquirySelectReady = true;
  var states = new WeakMap();
  var active = null;
  var nextId = 0;
  var checkSvg = '<svg class="cpk-heard__check" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function setup(root) {
    if (states.has(root)) { return; }
    var select = root.querySelector('select');
    if (!select || !select.options.length) { return; }
    var button = document.createElement('button');
    var listId = 'CpkHeardList-' + (++nextId);
    button.type = 'button';
    button.className = 'cpk-heard__button';
    button.id = listId + '-button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', listId);
    button.innerHTML = '<span></span><svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M3 5l4 4 4-4"/></svg>';
    var list = document.createElement('div');
    list.id = listId;
    list.className = 'cpk-heard__list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Where did you hear about us?');
    list.hidden = true;
    var options = null;
    var previous = -1;
    var typed = '', typedAt = 0;

    // Build the option DOM only on first use, in a detached fragment.
    function build() {
      if (options) { return; }
      options = [];
      var fragment = document.createDocumentFragment();
      function add(option, parent) {
        var item = document.createElement('div');
        item.className = 'cpk-heard__option';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.tabIndex = -1;
        item.dataset.index = options.length;
        var text = document.createElement('span');
        text.textContent = option.textContent;
        item.appendChild(text);
        item.insertAdjacentHTML('beforeend', checkSvg);
        parent.appendChild(item);
        options.push(item);
      }
      Array.prototype.forEach.call(select.children, function (child) {
        if (child.tagName === 'OPTGROUP') {
          var group = document.createElement('div');
          group.setAttribute('role', 'group');
          group.setAttribute('aria-label', child.label);
          var heading = document.createElement('div');
          heading.className = 'cpk-heard__group-label';
          heading.setAttribute('aria-hidden', 'true');
          heading.textContent = child.label;
          group.appendChild(heading);
          Array.prototype.forEach.call(child.children, function (option) { add(option, group); });
          fragment.appendChild(group);
        } else if (child.tagName === 'OPTION') { add(child, fragment); }
      });
      list.appendChild(fragment);
    }

    function sync() {
      var index = select.selectedIndex;
      var text = index < 0 ? '' : select.options[index].textContent;
      button.firstElementChild.textContent = text;
      button.setAttribute('aria-label', 'Where did you hear about us? ' + text);
      if (options) {
        if (options[previous]) { options[previous].setAttribute('aria-selected', 'false'); }
        if (options[index]) { options[index].setAttribute('aria-selected', 'true'); }
        previous = index;
      }
    }
    function close(focus) {
      if (list.hidden) { return; }
      list.hidden = true;
      root.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      if (active === state) { active = null; }
      if (focus) { button.focus({ preventScroll: true }); }
    }
    function focusOption(index) {
      var item = options[index];
      if (!item) { return; }
      item.focus({ preventScroll: true });
      // Scroll only the menu, preserving the page/panel position.
      var top = item.getBoundingClientRect().top - list.getBoundingClientRect().top + list.scrollTop;
      if (index === 0) { list.scrollTop = 0; }
      else if (top < list.scrollTop) { list.scrollTop = top; }
      else if (top + item.offsetHeight > list.scrollTop + list.clientHeight) {
        list.scrollTop = top + item.offsetHeight - list.clientHeight;
      }
    }
    function open(edge) {
      if (active && active !== state) { active.close(); }
      build();
      sync();
      list.hidden = false;
      root.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      active = state;
      typed = '';
      focusOption(edge === 'first' ? 0 : edge === 'last' ? options.length - 1 : Math.max(0, select.selectedIndex));
    }
    var state = { root: root, close: close, sync: sync };
    states.set(root, state);
    root.addEventListener('click', function (evt) {
      var option = evt.target.closest('.cpk-heard__option');
      if (option && list.contains(option)) {
        select.selectedIndex = Number(option.dataset.index);
        select.dispatchEvent(new Event('change', { bubbles: true }));
        close(true);
      } else if (button.contains(evt.target)) {
        if (list.hidden) { open(); } else { close(); }
      }
    });
    root.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape' && !list.hidden) {
        evt.preventDefault(); evt.stopPropagation(); close(true); return;
      }
      if (evt.key === 'Tab') {
        if (!list.hidden) { button.focus({ preventScroll: true }); close(); }
        return;
      }
      var focused = document.activeElement;
      var index = focused && focused.hasAttribute('data-index') ? Number(focused.dataset.index) : -1;
      if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp' || evt.key === 'Home' || evt.key === 'End') {
        evt.preventDefault();
        if (list.hidden) { open(evt.key === 'Home' ? 'first' : evt.key === 'End' ? 'last' : ''); return; }
        focusOption(evt.key === 'Home' ? 0 : evt.key === 'End' ? options.length - 1 :
          Math.max(0, Math.min(options.length - 1, index + (evt.key === 'ArrowDown' ? 1 : -1))));
      } else if ((evt.key === 'Enter' || evt.key === ' ') && index >= 0) {
        evt.preventDefault(); options[index].click();
      } else if (!list.hidden && evt.key.length === 1 && !evt.ctrlKey && !evt.metaKey && !evt.altKey) {
        evt.preventDefault();
        var now = Date.now();
        typed = (now - typedAt > 700 ? '' : typed) + evt.key.toLowerCase();
        typedAt = now;
        for (var i = 0; i < options.length; i++) {
          if (select.options[i].textContent.toLowerCase().indexOf(typed) === 0) { focusOption(i); break; }
        }
      }
    });
    root.addEventListener('focusout', function (evt) {
      if (!root.contains(evt.relatedTarget)) { close(); }
    });
    root.appendChild(button);
    root.appendChild(list);
    Array.prototype.forEach.call(Array.prototype.slice.call(select.labels || []), function (label) { label.htmlFor = button.id; });
    select.hidden = true;
    sync();
  }

  function init(container) {
    Array.prototype.forEach.call(container.querySelectorAll('[data-cpk-heard]'), setup);
  }
  // Shared document listeners also cover sections replaced in the theme editor.
  document.addEventListener('click', function (evt) {
    if (active && !active.root.contains(evt.target)) { active.close(); }
  });
  document.addEventListener('change', function (evt) {
    var root = evt.target.closest('[data-cpk-heard]');
    var state = root && states.get(root);
    if (state && evt.target.tagName === 'SELECT') { state.sync(); }
  });
  document.addEventListener('reset', function (evt) {
    var form = evt.target;
    setTimeout(function () {
      if (evt.defaultPrevented) { return; }
      Array.prototype.forEach.call(form.querySelectorAll('[data-cpk-heard]'), function (root) {
        var state = states.get(root);
        if (state) { state.sync(); state.close(); }
      });
    }, 0);
  });
  document.addEventListener('shopify:section:load', function (evt) { init(evt.target); });
  document.addEventListener('shopify:section:unload', function (evt) {
    if (active && evt.target.contains(active.root)) { active.close(); }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else { init(document); }
})();
